import ufeApi from 'services/api/ufeApi';
import { gqlClient } from 'services/api/gql/gqlClient';
import { UpdateSmsNotification } from 'constants/gql/mutations/checkout/updateSmsNotification.gql';

function setSmsSignup(payload) {
    const oxsUrl = '/api/checkout/orders/smsUpdate';

    const globalEnabled = Sephora?.configurationSettings?.oisMigration?.global?.isEnabled;
    const modificationEnabled = Sephora?.configurationSettings?.oisMigration?.modification?.isEnabled;

    const shouldUseOIS = globalEnabled && modificationEnabled;

    if (shouldUseOIS) {
        return gqlClient
            .query({
                operationName: 'UpdateSmsNotification',
                query: UpdateSmsNotification,
                variables: {
                    input: payload
                }
            })
            .then(data => {
                const result = data?.updateSmsNotification;

                if (result?.responseCode && result.responseCode !== 'SUCCESS') {
                    const error = new Error(result.message || 'SMS notification update failed');
                    error.errorCode = result.responseCode;
                    error.errorMessages = result.message ? [result.message] : [];

                    return Promise.reject(error);
                }

                return data;
            });
    }

    return ufeApi
        .makeRequest(oxsUrl, {
            method: 'POST',
            body: JSON.stringify(payload)
        })
        .then(data => (data?.errorCode ? Promise.reject(data) : data));
}

export default setSmsSignup;
